export default __webpack_public_path__ + "static/media/mobile6.20379a9c.jfif";